<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="row">
        <div class="col-md-12" *ngIf="id == 'H'">
        <div class="card">
            <div class="card-header">
                <form>
                    <div class="input-group mb-3 no-print">
                        <input type="text" class="form-control" placeholder="กรอกรหัสกลุ่ม" id="groupcode" name="groupcode">
                        <button class="btn btn-primary" (click)="Loadreportplantcup();">ค้นหา</button>
                        <button  mat-raised-button color="warn"  (click)="print()">ออกเอกสาร</button>
                    </div>
                </form>
            </div>
            <div class="card-body">
                <img mat-card-image src="../../../../assets/images/bsfLogo.jpg" style="width: 50%; margin-left: 25%;"> <br> <br>
                <h2 *ngFor="let item of datagroup">ชื่อกลุ่ม : {{item.groupname}} รหัส : {{item.categoryGroup}} หัวหน้ากลุ่ม : {{item.h_fmname}} ประเภทคิว : {{item.qdesc}}</h2>
                <table class="table">
                    <thead>
                        <th scope="col">ชื่อ - สกุล</th>
                        <th scope="col">เลขแปลง</th>
                        <th scope="col">พื้นที่</th>
                        <th scope="col">พันธุ์</th>
                        <th scope="col">โซน</th>
                        <th scope="col">รูท</th>
                        <th scope="col">อายุ</th>
                        <th scope="col">ตัน</th>
                        <th scope="col">ประเมิน</th>
                        <th scope="col" style="text-align: center;">ลำดับตัด</th>
                        <th scope="col" style="text-align: center;">วันที่ตัด</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of datareportplantcup; index as i">
                            <td> <label *ngIf="item.supzone==null" style="text-decoration: underline;">{{item.fmname}}</label> <p *ngIf="item.supzone!=null">{{item.fmname}}</p></td>
                            <!-- <td>{{item.fmname}}</td> -->
                            <td>
                                <label *ngIf="item.supzone==null" style="text-decoration: underline;">{{item.intlandno}}</label> <p *ngIf="item.supzone!=null">{{item.intlandno}}</p>
                            </td>
                            <td><label *ngIf="item.supzone==null" style="text-decoration: underline;">{{item.landvalue.toLocaleString('ar-TH')}}</label> <p *ngIf="item.supzone!=null">{{item.landvalue.toLocaleString('ar-TH')}}</p></td>
                            <td>{{item.seedname}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.route}}</td>
                            <td>{{item.caneage}}</td>
                            <td>{{item.ton}}</td>
                            <td>
                                <label *ngIf="item.supzone==null" style="text-decoration: underline;">{{item.Assess.toLocaleString('ar-TH')}}</label> <p *ngIf="item.supzone!=null">{{item.Assess.toLocaleString('ar-TH')}}</p>
                            </td>
                            <td>....................</td>
                            <td>....................</td>
                        </tr>
                        
                    </tbody>
                </table> <br>
                วันที่พิมพ์เอกสาร {{today}}

                <div class="row">
                    <div class="col-6" style="margin-left: 10%;">
                     
                     
                    </div>
                    <div class="col-4"> <br><br><br>
                      <p>ลงชื่อ ..................................................</p>
                      <p>&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp;&nbsp;หัวหน้ากลุ่ม</p>
                      <p>ลงชื่อ ..................................................</p>
                      <p>&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;พนักงานส่งเสริม</p>
                      <p>วันที่ (............./............./..............)</p>
                    </div>
                </div>
            </div>
            
        </div>
        </div>
    </div>
  

    <div class="row">
        <div class="col-md-12" *ngIf="id == 'M'">
            <div class="card">
                <div class="card-header">
                    <form>
                        <div class="input-group mb-3 no-print">
                            <input type="text" class="form-control" placeholder="กรอกรหัสกลุ่ม" id="groupcode" list="repairtcode" maxlength="6">
                            <datalist id="repairtcode">
                                <option *ngFor="let item of repairtg">{{item.groupcode}} | {{item.groupname}}</option>
                            </datalist>
                            <button class="btn btn-primary" (click)="Loadreportplantrepair();">ค้นหา</button>
                            <input type="text" class="form-control" placeholder="ยังไม่จัดกลุ่ม ให้ใช้เขตในการค้นข้อมูล" [(ngModel)]="ungroup" [ngModelOptions]="{standalone: true}" maxlength="6">
                            <button class="btn btn-primary" (click)="Loadreportplantrepairbyzone();">ค้นหาโดยเขต</button>
                            <button  mat-raised-button color="warn"  (click)="print()">ออกเอกสาร</button>
                        </div>
                    </form>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="content col-12">
                            <img src="../../../../assets/images/bsflogo.png">
                            <h2>&nbsp;รายงานข้อมูลแปลงอ้อยสำหรับกลุ่มบำรุง</h2>
                            <h3>&nbsp;&nbsp;ประจำปีการผลิต 2565/2566</h3> <br>
                            <h3 *ngFor="let item of datagroup" class="text-center">ชื่อกลุ่ม : {{item.groupname}} รหัส : {{item.categoryGroup}} หัวหน้ากลุ่ม : {{item.h_fmname}} </h3>
                        </div>
                        <!-- <div class="col-8 text-center">
                            
                        </div> -->
                    </div>
                    
                  
                    <table class="table">
                        <thead class="table table-secondary">
                            <th scope="col">#</th>
                            <th scope="col">ข้อมูลแปลง</th>
                            <th scope="col">ระเบิดดาน</th>
                            <th scope="col">พันธุ์อ้อย</th>
                            <th scope="col">ระยะร่อง</th>
                            <th scope="col">เคมี 1</th>
                            <th scope="col">เคมี 2</th>
                            <th scope="col">เคมี 3</th>
                            <th scope="col">อินทรีย์</th>
                            <th scope="col">โดโลไมท์</th>
                            <th scope="col">%งอก</th>
                            <th scope="col">วัชพืช</th>
                            <th scope="col">โรค/แมลง</th>
                            <th scope="col">ปริมาณอ้อยประเมิน</th>
                            <th scope="col">ประเมิน</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of datareportplantrepair; index as i" 
                            [ngClass]="{'table table-secondary text-bold':item.fmname.slice(0,3) == 'รวม','table-primary':item.fmcode =='sum'}">
                                <td>{{i+1}}</td>
                                <td>{{item.intlandno}} {{item.fmname}} {{item.CaneTypeName}} {{item.landvalue}} <label *ngIf="item.landvalue != null"> ไร่ </label> &nbsp;
                                    <label *ngIf="item.route != null"> รูท </label>  {{item.route}} 
                                    <label *ngIf="item.supzone != null"> โซน</label> {{item.supzone}} 
                                    <label *ngIf="item.caneage != null"> อายุ</label>  {{item.caneage}} <label *ngIf="item.caneage != null">วัน </label></td>
                                <td> {{item.hardSoilBlast_doc}}</td>
                                <td>{{item.seedname}}</td>
                                <td>{{item.Groove + item.ck_Groove}}</td>
                                <td>{{item.AmountFertilizerRound + item.Fertilizer1}}</td>
                                <td>{{item.AmountFertilizerRound2 + item.Fertilizer2}}</td>
                                <td>{{item.AmountFertilizerRound3 + item.Fertilizer3}}</td>
                                <td>{{item.AmountNaturalFertilizer + item.Natural}}</td>
                                
                                <td>{{item.AmountDolomite + item.Dolomite}}</td>
                                <td>{{item.lastGerminationPercent|number}}{{item.Germination}}</td>
                                <td>{{item.lastweed_doc}}</td>
                                <td>{{item.lastDisease_doc}}</td>
                                <!-- ประเมิน นสส แล้วก็ ชาวไร่ -->
                                <td>{{item.Assess|number}}</td>
                                <td class="text-right">{{item.ton|number}}</td>
                            </tr>
                            <tr *ngFor="let item of sunland">
                                <td colspan="15" class="table-secondary text-bold text-center">รวม {{item.sunplant}} แปลง  {{item.sumlandvalue | number}} ไร่ ประเมินอ้อย {{item.sumAssess | number}} ตัน 
                                    ผลผลิต {{item.sumlandton | number}} ตัน/ไร่</td>
                            </tr>
                            <tr *ngFor="let item of sunland">
                                <td colspan="15" class="table-secondary text-center">ผลผลิตเฉลี่ยของกลุ่ม อ้อยปลายฝน {{item.sumER | number}} อ้อยตอ {{item.sumST | number}} อ้อยต้นฝน {{item.sumSR | number}}</td>
                            </tr>
                             
                        </tbody>
                        <thead>
                            <tr>
                                <td scope="col" class="text-bold" colspan="15">สรุปกิจกรรมตามช่วงเวลา</td>
                            </tr>
                           
                        </thead>
                        <tbody>
                            <tr class="table-secondary">
                                <th scope="col" colspan="15"></th>	
                            </tr>
                        </tbody> 
                        <thead>
                            <tr>
                                <td scope="col" class="text-bold" colspan="15">รายการเครื่องมือ อุปกรณ์ ในกลุ่ม</td>
                            </tr>
                           
                        </thead>
                        <tbody>
                            <tr class="table-secondary">
                                <th scope="col"></th>					
                                <th scope="col">รายการ</th>
                                <th scope="col">ยี่ห้อ</th>
                                <th scope="col">รุ่น</th>
                                <th scope="col">แรงม้า</th>
                                <th scope="col">กำลัง/วัน</th>
                                <th scope="col">ทะเบียน</th>
                            </tr>
                            <tr *ngFor="let item of toolsrepair; index as s">
                                <td>{{s+1}}</td>
                                <td>{{item.Tools_docs}}</td>
                                <td>{{item.brand_name}}</td>
                                <td>
                                    <label *ngIf="item.Model_brand != 'null' "> {{item.Model_brand}}</label>
                                </td>
                                <td class="text-right">{{item.horsepower}}</td>
                                <td class="text-right">{{item.canePerDay}}</td>
                                <td>
                                    <label *ngIf="item.reg_num != 'null' "> {{item.reg_num}}</label>
                                </td>
                            </tr>
                        </tbody>
                    </table> <br>
                    
    
                    <div class="row ">
                        <div class="col-6 text-bold" style="margin-left: 2%;">
                         <p>หมายเหตุ</p> <br>
                         ..............................................................................................................................................
                         .............................................................................................................................................. <br>
                         ..............................................................................................................................................
                         
                        </div>
                        <div class="col-4 text-bold"> <br><br><br>
                          <p class="text-bold">ลงชื่อ ..................................................หัวหน้ากลุ่ม</p>
                          <p class="text-bold">ลงชื่อ ..................................................นักส่งเสริม</p>
                          <p class="text-bold">ลงชื่อ ..................................................ผจกโซน</p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>